import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { setLocation } from 'shared/actions/globals';
import { getDisplayName } from 'shared/helpers/common';
import { toLocalized } from 'shared/helpers/locale';
import { urlReplaceSlash } from 'shared/modules';
import history from '../../history';
import {
  generateDealersSearchUrl,
  generateFirmsSearchUrl,
  generateSearchUrl,
  generateSparesSearchUrl,
} from '../helpers/urls';

const withFooterLocations = WrappedComponent =>
  class extends React.Component {
    static displayName = `withFooterLocations(${getDisplayName(WrappedComponent)})`;

    static propTypes = {
      list: PropTypes.arrayOf(
        PropTypes.arrayOf(
          PropTypes.shape({
            title: PropTypes.string.isRequired,
            slug: PropTypes.string.isRequired,
            id: PropTypes.number.isRequired,
          }),
        ),
      ),
      onLocationChange: PropTypes.func.isRequired,
      className: PropTypes.string.isRequired,
      routeName: PropTypes.string,
      historyStore: PropTypes.shape(),
      formState: PropTypes.shape().isRequired,
      resetHeader: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
      locale: PropTypes.string.isRequired,
      seoSearchUrlResponse: PropTypes.shape(),
    };

    static defaultProps = {
      list: [],
      className: '',
      historyStore: {},
      locationLinkBuilder: null,
      routeName: null,
      resetHeader: null,
      seoSearchUrlResponse: {},
    };

    getPath = (routeName, state, location) => {
      const transport =
        state.transport ||
        (this.props.seoSearchUrlResponse && this.props.seoSearchUrlResponse.transport);
      const make =
        (state.make && state.make.slug) ||
        (this.props.seoSearchUrlResponse && this.props.seoSearchUrlResponse.make);

      const params = { ...state, make, transport, location };

      switch (routeName) {
        case 'search':
          return generateSearchUrl(params);
        case 'moto':
          return `/moto/${location ? location.slug : ''}/`;
        case 'commercial':
          return `/commercial/${location ? location.slug : ''}/`;
        case 'dealers':
          return generateDealersSearchUrl(params);
        case 'firms':
          return generateFirmsSearchUrl(params);
        case 'auto-parts':
          return generateSparesSearchUrl(params);

        default:
          if (transport && transport.slug) {
            return `/${transport.slug}/${location ? location.slug : ''}/`;
          }

          return location ? location.slug : '';
      }
    };

    handleLinkClick = (e, location) => {
      const { routeName } = this.props;
      e.preventDefault();
      this.props.onLocationChange(location);

      if (routeName) {
        history.push(this.updateUrl(location));
      } else {
        history.push();
      }
    };

    updateUrl = (location, url) => {
      const { formState, locale, routeName } = this.props;
      const state = { ...formState, location };
      const pathname = this.getPath(routeName, state, location);

      if (url) {
        return toLocalized(urlReplaceSlash(url), locale);
      }

      if (routeName === 'home' && typeof pathname === 'string' && pathname.includes('avto/')) {
        return toLocalized(urlReplaceSlash(pathname), locale);
      }

      return toLocalized(
        urlReplaceSlash(`/${routeName === 'home' ? 'avto/' : ''}${pathname}/`),
        locale,
      );
    };

    render() {
      return (
        <WrappedComponent
          {...this.props}
          getPath={this.getPath}
          updateUrl={this.updateUrl}
          handleLinkClick={this.handleLinkClick}
        />
      );
    }
  };

const mapStateToProps = ({ globals, history: historyState, searchForm }) => ({
  locale: globals.locale,
  location: globals.location,
  routeName: historyState && historyState.currentRouteName,
  formState: searchForm && searchForm.selected,
  currentPath: historyState.currentPath,
  seoSearchUrlResponse: globals.seoSearchUrlResponse,
});
const mapDispatchToProps = {
  onLocationChange: setLocation,
};

export default component =>
  connect(mapStateToProps, mapDispatchToProps)(withFooterLocations(component));



// WEBPACK FOOTER //
// ./src/shared/hocs/withFooterLocations.js